import { Injectable } from '@angular/core';
import { Util } from '../../util';
import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import {
  CareerPlan,
  CareerPlanResource,
  CareerPlanSkillDetail,
  CompletedCareerPlans,
} from '../../models/career-plans';
import { tap } from 'rxjs/operators';
import { Record } from 'src/app/models/record';

@Injectable({
  providedIn: 'root',
})
export class CareerPlansApiService {
  API_URL: string;

  constructor(private http: HttpClient) {
    const url = new URL(Util.getOrigin());
    this.API_URL = `${url.origin}/opac/api/v2/career-plans`;
  }

  public getCurrentCareerPlan(): Observable<CareerPlan> {
    return this.http.get<CareerPlan>(`${this.API_URL}/current`);
  }

  public getSkillDetail(skillId: string): Observable<CareerPlanSkillDetail> {
    return this.http
      .get<CareerPlanSkillDetail>(`${this.API_URL}/skills/${skillId}`)
      .pipe(tap((skillDetail) => this.resolveSkillResourcesIcons(skillDetail)));
  }

  public getCareerPlanHistory(): Observable<CompletedCareerPlans> {
    return this.http.get<CompletedCareerPlans>(`${this.API_URL}/history`);
  }

  public getCareerPlanDetail(careerPlanId: string): Observable<CareerPlan> {
    return this.http.get<CareerPlan>(`${this.API_URL}/${careerPlanId}/detail`);
  }

  private resolveSkillResourcesIcons(skillDetail: CareerPlanSkillDetail) {
    skillDetail.levels.forEach((level) => {
      this.resolveLevelResourcesIcons(level.resourcesObligatory);
      this.resolveLevelResourcesIcons(level.resourcesOptional);
    });
  }

  private resolveLevelResourcesIcons(resources: CareerPlanResource[] | Record[]) {
    resources.forEach((resource) => {
      if (resource.resourceTypes?.length) {
        resource.icon = Util.resolveIcon(resource.resourceTypes[0]);
      }
      if (resource.learningExperienceId) {
        resource.icon = Util.resolveIcon(resource.specialFormat, resource.iconId);
      }
    });
  }
}
